<template>
  <div class="UpgradeToGold">
    <div class="subscriptions-block">
      <div class="subscriptions-title">
        <div class="icon-top-1">
          <img class="my-sub-icon" src="../../../assets/img/svg/my-sub.svg" />
        </div>
        <div class="top-title-1">My Subscriptions</div>
      </div>
      <div class="subscriptions-content">
        <v-row>
          <v-col cols="11">
            <div>
              <div class="username-sub">Hi {{ user.name }}</div>
              <div class="sub-title-sub">Your active subscriptions are:</div>
              <div class="trial-row">
                <div class="trial-col">
                  <ul>
                    <li v-if="!user.subscription_details || (user.subscription_details && !user.subscription_details.length)">
                      {{'No active subscription'}}
                    </li>
                    <li
                      v-for="(item,index) in user.subscription_details"
                      v-if="index % 2 === 0 && (item.is_purchased ||  item.is_subscribed || item.institute_purchased)"
                    >
                    {{item.length == 0 ? 'No active subscription': ''}}
                      {{ item.name}}
                      {{ item.name !=="Boost Up" &&item.product_name.length ?' - ' + item.product_name.join(", ") : ''}}
                      <span class="expiry-date-span">{{
                        item.institute_purchased && !item.is_subscribed
                          ? ""
                          : expiryDate(item.expiry_date)
                      }}</span>
                    </li>
                  </ul>
                </div>
                <div class="trial-col-divider"></div>
                <div class="trial-col">
                  <ul>
                    <li
                      v-for="(item, index) in user.subscription_details"
                      v-if="index % 2 !== 0 && (item.is_purchased ||  item.is_subscribed || item.institute_purchased)"
                    >
                      {{ item.name }}{{ item.product_name.length ? ' - ' + item.product_name.join(", ") : ''}}
                      <span class="expiry-date-span">{{
                        item.institute_purchased && !item.is_subscribed
                          ? ""
                          : expiryDate(item.expiry_date)
                      }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapState, mapActions } from "vuex";
import moment from "moment";

//import Subscription from "@/views/pages/Subscription/Subscription.vue";
//import PackagesList from "@/components/student/UpgradeToGold/PackagesList.vue";
export default {
  name: "MySubscription",
  components: {
    //PackagesList,
    //Subscription
  },
  mounted() {},
  methods: {
    expiryDate(expiryDate) {
      return expiryDate
        ? "- valid up to " + moment(expiryDate).format("DD-MMM-YYYY")
        : "";
    },
  },
  computed: {
    ...mapState("userStore", ["user"]),
  },
};
</script>
